// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSessionUser } from '../../SessionContext';
import { getTokenRole } from '../../services/api';

const normalizeRole = (value) => String(value || '').trim().toUpperCase();

const PrivateRoute = ({ children, allowRoles = null, denyRoles = null, redirectTo = '/frontoffice-new' }) => {
  const { isAuthenticated, user } = useSessionUser();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Use JWT token role (tamper-proof) with fallback to context role
  const role = getTokenRole() || normalizeRole(user?.roleName);

  const allowed = Array.isArray(allowRoles) ? allowRoles.map(normalizeRole) : null;
  const denied = Array.isArray(denyRoles) ? denyRoles.map(normalizeRole) : null;

  if (allowed && allowed.length > 0 && !allowed.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }
  if (denied && denied.length > 0 && denied.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PrivateRoute;
